<template>
  <v-dialog
    max-width="700"
    :value="!!obligation"
    persistent
    :fullscreen="$vuetify.breakpoint.smAndDown"
    @keydown.esc="close()"
  >
    <v-card tile v-if="obligation && summary">
      <v-app-bar dark flat color="primary">
        <v-btn icon dark @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
        <span class="title">Propagar etiquetas: {{ obligation.name }}</span>
      </v-app-bar>
      <v-card-text class="pt-4">
        <v-alert v-if="errorMessage" type="error" dense text>{{ errorMessage }}</v-alert>
        <p class="caption grey--text">
          {{ summary.total }} {{ summary.total === 1 ? "obligación cargada" : "obligaciones cargadas" }} de este tipo.
        </p>

        <div class="subtitle-2 mb-2">Etiquetas declaradas</div>
        <p v-if="summary.declared.length === 0" class="grey--text">
          La obligación no tiene etiquetas declaradas.
        </p>
        <v-list dense class="py-0">
          <v-list-item v-for="tag in summary.declared" :key="tag._id" class="px-0">
            <v-list-item-content>
              <div>
                <v-chip small label :color="tagBackground(tag)" :text-color="textColorFor(tagBackground(tag))">
                  {{ tag.name }}
                </v-chip>
                <span class="caption grey--text ml-2">{{ tag.tagged }} de {{ summary.total }}</span>
                <v-btn icon x-small class="ml-1" title="Ver cuáles la tienen" @click="openDetail(tag)">
                  <v-icon small>visibility</v-icon>
                </v-btn>
              </div>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn small color="primary" :disabled="tag.complete || saving" @click="assign(tag)">
                Asignar a todas
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>

        <template v-if="summary.undeclared.length > 0">
          <v-divider class="my-4"></v-divider>
          <div class="subtitle-2 mb-2">Etiquetas no declaradas asignadas a algunas obligaciones</div>
          <v-list dense class="py-0">
            <v-list-item v-for="tag in summary.undeclared" :key="tag._id" class="px-0">
              <v-list-item-content>
                <div>
                  <v-chip small label :color="tagBackground(tag)" :text-color="textColorFor(tagBackground(tag))">
                    {{ tag.name }}
                  </v-chip>
                  <span class="caption grey--text ml-2">{{ tag.tagged }} de {{ summary.total }}</span>
                  <v-btn icon x-small class="ml-1" title="Ver cuáles la tienen" @click="openDetail(tag)">
                    <v-icon small>visibility</v-icon>
                  </v-btn>
                </div>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn small color="error" :disabled="saving" @click="removeFromAll(tag)">
                  Sacar etiqueta en todas
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </template>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close()">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
    <tag-propagation-detail
      v-if="detailTag"
      :obligation="obligation"
      :tag="detailTag"
      @close="detailTag = null"
    />
  </v-dialog>
</template>

<script>
"use strict";

import obligationService from "@/services/ObligationService";
import { tagBackground, textColorFor } from "@/utils/tag-color";
import tagPropagationDetail from "@/components/views/obligations/tag-propagation-detail.component.vue";

// Modal "Propagar etiquetas" de /obligations. El listado abre el modal recien
// cuando ya cargo el estado (prop summary), asi los botones nacen con el
// estado correcto.
export default {
  name: "tag-propagation",
  components: { tagPropagationDetail },
  props: {
    obligation: { type: Object, default: null },
    initialSummary: { type: Object, default: null }
  },
  data() {
    return {
      summary: this.initialSummary,
      saving: false,
      detailTag: null,
      errorMessage: null
    };
  },
  watch: {
    initialSummary(value) {
      this.summary = value;
      this.errorMessage = null;
    }
  },
  methods: {
    tagBackground,
    textColorFor,
    close() {
      this.$emit("close");
    },
    openDetail(tag) {
      this.detailTag = tag;
    },
    async assign(tag) {
      await this.confirmAndRun(
        `Asignar ${tag.name}`,
        "Si continúa, se asignará esta etiqueta a todas las obligaciones de este tipo.",
        "assign",
        tag
      );
    },
    async removeFromAll(tag) {
      await this.confirmAndRun(
        `Sacar ${tag.name}`,
        "Si continúa, se retirará esta etiqueta de todas las obligaciones de este tipo que estén marcadas.",
        "remove",
        tag
      );
    },
    async confirmAndRun(title, content, action, tag) {
      try {
        await this.botConfirmDialog({ title, content });
      } catch (cancelled) {
        return;
      }
      this.errorMessage = null;
      this.saving = true;
      try {
        // La respuesta trae el estado nuevo: la declarada queda completa (boton
        // gris) y la no declarada desaparece de la lista.
        this.summary = await obligationService.propagateTag(this.obligation._id, action, tag._id);
      } catch (error) {
        this.errorMessage =
          (error.response && error.response.data && error.response.data.message) ||
          "No se pudo actualizar la etiqueta";
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>
